import { KeyManagerSport } from 'features/sport/utils/keyManager';
import { ScommesseMarcatoriRenderConditional } from 'features/sport/components/sportMarcatoriRenderConditional';
import { selectSelectedAvvenimento } from 'features/sport/selectors';
import { useTypedSelector } from 'lib/centralStore';

export type PlayerInfoType = {
  playerKey: string;
  infoTipoScommessaKeyList: Array<string>;
  hasTitle?: boolean;
  showMultipleBox?: boolean;
  hasHeader?: boolean;
  isAvvenimentoTemplate?: boolean;
  isPrincipaliFilter?: boolean;
  isTooltipClicked?: boolean;
  setIsTooltipClicked?: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ScommesseMarcatoriRender = ({
  infoTipoScommessaKeyList,
  playerKey,
  hasTitle,
  showMultipleBox,
  hasHeader,
  isAvvenimentoTemplate,
  isPrincipaliFilter,
  isTooltipClicked,
  setIsTooltipClicked,
}: PlayerInfoType) => {
  const { avvenimentoKey } = useTypedSelector(selectSelectedAvvenimento) ?? {};

  return infoTipoScommessaKeyList.map((tipoScommessaId) => {
    const { scommessaKey } = new KeyManagerSport(`${avvenimentoKey}-${tipoScommessaId}`);
    const { infoAggiuntivaId } = new KeyManagerSport(playerKey);
    const finalPlayerKey = new KeyManagerSport(`${scommessaKey}-${infoAggiuntivaId}`);

    return (
      <ScommesseMarcatoriRenderConditional
        date-test-id={finalPlayerKey.scommessaKey}
        key={finalPlayerKey.infoAggiuntivaKey}
        hasTitle={hasTitle}
        playerKey={finalPlayerKey.infoAggiuntivaKey}
        showMultipleBox={showMultipleBox}
        hasHeader={hasHeader}
        isAvvenimentoTemplate={isAvvenimentoTemplate}
        isPrincipaliFilter={isPrincipaliFilter}
        setIsTooltipClicked={setIsTooltipClicked}
        isTooltipClicked={isTooltipClicked}
      />
    );
  });
};